module.exports = __webpack_public_path__ + "static/design-7f1fc1baa9bac30ab63e3f9d235663a6.jpg";